import React from "react";
import { Loader2 } from "lucide-react";

// Calcul en cours : roue animée et secondes écoulées, sans pourcentage inventé (le serveur ne donne pas d'étapes).
export default function GeotabBusy({ title, detail }) {
  const [seconds, setSeconds] = React.useState(0);
  React.useEffect(() => {
    const started = Date.now();
    const timer = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div role="status" className="flex items-center gap-2.5 rounded-[4px] border border-slate-200 bg-white px-3 py-2">
      <Loader2 size={22} aria-hidden="true" className="shrink-0 animate-spin text-accent motion-reduce:animate-none" />
      <span className="min-w-0">
        <strong className="block text-[13px] font-semibold text-slate-800">{title}</strong>
        <span className="block text-[11.5px] text-slate-500">
          {detail}
          {/* Hors de l'annonce aux lecteurs d'écran : sinon relue chaque seconde. */}
          <span aria-hidden="true" className="tabular-nums">{detail ? " · " : ""}{seconds} s</span>
        </span>
      </span>
    </div>
  );
}
